export default __webpack_public_path__ + "static/atr-772673f81bc0834ea1d6df0519c7e0af.png";